//import SignersList from "../../SignersList";
import {
  GridContainer,
  Form,
  FormButton,
} from "../GeneralStyles/styles";

const OwnerRegister: React.FC = () => {
  return (
    <>
      <Form>
        <label>Nome do proprietário:</label>
        <input />
        <GridContainer>
          <label>CPF:</label>
          <label>Nacionalidade:</label>
          <input />
          <select></select>
          <label>Ocupação:</label>
          <label>Estado civil:</label>
          <input />
          <select></select>
        </GridContainer>
        <FormButton>Adicionar signatário</FormButton>
      </Form>
      {/* <SignersList /> */}
    </>
  );
};

export default OwnerRegister;
